import React, { useEffect, useState } from 'react'
import s from './SelectProfessional.module.scss'
import Card from './Card'
import useGetServicesTeamsByServiceId from 'sdk/hooks/booking/useGetServicesTeamsByServiceId'
import Button from 'components/shared/Button'
import { useTranslation } from 'react-i18next'

const SelectProfessional = ({ selectedService, selectedId, handleChoose, handleNext }: any) => {
    const { data: professionals, refetch } = useGetServicesTeamsByServiceId(selectedService)
 const {t} = useTranslation() as any
    useEffect(() => {
        refetch()
    }, [selectedService])

    const uniqueProfessionals = professionals?.filter((item, index, self) =>
  index === self.findIndex((t) => t.teams.id === item?.teams.id)
);



    return (
        <div className={s.select_prof}>
            <div className={s.select_prof_title}>
                 {t("Select the professional for")}  <span style={{ color: '#C555B4' }}>{professionals?.[0]?.service?.name}</span>
            </div>

            <div className={s.select_cards}>
                {uniqueProfessionals?.map((item) => {
                    return (
                        <Card
                            key={item?.id}
                            id={item?.teams?.id}
                            avatar={item?.teams?.avatar}
                            fullName={item?.teams?.full_name}
                            selectedId={selectedId}
                            handleChoose={handleChoose}
                        />
                    )
                })}


                 {uniqueProfessionals?.length === 0 ? <>There is no one right now availible to do the services</> : "" }


            </div>
            <div className={s.select_prof_action}>
                <Button
                    className={s.select_button}
                    wide
                    darkGreen
                    disabled={!selectedId}
                    onClick={handleNext}
                >
                    {t('Book now')}
                </Button>
            </div>
        </div>
    )
}

export default SelectProfessional
